export default "__VITE_ASSET__szk6rH5v__"